import { render } from "./App.vue?vue&type=template&id=1a7094ec&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=1a7094ec&lang=scss"

import exportComponent from "/home/nosaka_h/ghq/github.com/whi-product/ams-bot/company-oauth-success-screen/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__